export default __webpack_public_path__ + "static/media/picture4.dca3fb58.png";